import React from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import { ActivityIndicator, Drawer } from 'react-native-paper';
import { Button } from 'react-native-paper';
import SafeAreaView from 'react-native-safe-area-view';
import { t, Trans } from '@lingui/macro';
import { DrawerContentComponentProps } from '@react-navigation/drawer';
import { useIsDrawerOpen } from '@react-navigation/drawer';
import { DrawerActions, useIsFocused } from '@react-navigation/native';
import styled from 'styled-components/native';

import Avatar from '@src/components/Avatar';
import Divider from '@src/components/Divider';
import Image from '@src/components/Image';
import Separator from '@src/components/Separator';
import Subscription from '@src/components/Subsbcribtion';
import { Body1 } from '@src/components/Typography';
import { windowHeight, windowWidth } from '@src/configuration/constants';
import { padding } from '@src/configuration/constants';
import { remainingTime } from '@src/helpers';
import useActiveOnRegions from '@src/hooks/useActiveOnRegions';
import useAllAccessStatus from '@src/hooks/useAllAccessStatus';
import useLogout from '@src/hooks/useLogout';
import useProfile from '@src/hooks/useProfile';
import useRefreshPrimeStatus from '@src/hooks/useRefreshPrimeStatus';
import { i18n } from '@src/i18n';

const size_ = windowWidth * 0.84;
const Header = styled(SafeAreaView)`
  padding: ${padding}px;
`;

const Container = styled(SafeAreaView)`
  background-color: ${({ theme }) => theme.colors.background};
  flex: 1;
`;

const Center = styled.View`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;
const UserView = styled.View`
  align-items: center;
  margin-left: 16px;
`;

const PrimeExpiration = styled(Body1)`
  border: 1px solid ${({ theme }) => theme.colors.placeholder};
  border-radius: ${({ theme }) => theme.roundness / 2}px;
  padding: ${padding}px ${padding}px;
`;
export const PrimeButton = styled(Button).attrs(({ theme }) => ({
  color: theme.colors.text,
  mode: 'outlined',
  compact: true,
  uppercase: false,
  padding: 5,
  border: 1,
  borderWidth: 5,
  borderRadius: 8,
}))``;

const Icon = styled(Image)`
  width: 24px;
  height: 24px;
  resize-mode: contain;
`;
const Component: React.FC<DrawerContentComponentProps> = ({
  state,
  descriptors,
  navigation,
}) => {
  const logout = useLogout();

  const profile = useProfile();
  const isFocused = useIsFocused();
  let allAccessData = useAllAccessStatus();
  const regions = useActiveOnRegions('IR');
  const isOpen = useIsDrawerOpen();
  const refreshPrimeStatus = useRefreshPrimeStatus(true);

  React.useEffect(() => {
    console.log('ref');
    if (isOpen) refreshPrimeStatus().then(() => {});
  }, [isOpen]);

  return (
    <Container>
      <Header>
        <TouchableOpacity
          onPress={() => {
            navigation.dispatch(DrawerActions.closeDrawer());
            navigation.navigate('Profile');
          }}
        >
          <Center>
            <Avatar
              source={
                profile?.avatar ?? require('@src/assets/images/avatar.png')
              }
              size={82}
            />
            <UserView>
              {!!profile?.name && <Body1>{profile.name}</Body1>}
              {!!profile?.username && <Body1>{profile.username}@</Body1>}
            </UserView>
          </Center>
        </TouchableOpacity>
        {/* <Separator />
        {regions &&
          (hasPrime ? (
            <PrimeExpiration>
              {expire ? (
                <Trans>Prime expires in {expire} days</Trans>
              ) : (
                <ActivityIndicator size="small" />
              )}
            </PrimeExpiration>
          ) : (
            <PrimeButton
              onPress={() => {
                navigation.dispatch(DrawerActions.closeDrawer());
                navigation.navigate('PrimePlans');
              }}
            >
              <Trans>No prime subscription</Trans>
            </PrimeButton>
          ))} */}
      </Header>
      {allAccessData && (
        <Subscription
          size={windowWidth * 0.84}
          data={allAccessData}
          closeAction={() => navigation.dispatch(DrawerActions.closeDrawer())}
        />
      )}
      <Separator />
      <Divider />
      <Separator />
      <ScrollView style={{ minHeight: windowHeight }}>
        <Drawer.Section>
          {/* {state.routes
            // we don't need dashboard button in drawer
            .filter(({ key }) => !key.startsWith('Dashboard'))
            .filter(({ key }) => !key.startsWith('HeroesStack'))
            .filter(({ key }) => !key.startsWith('AddLocation'))
            .map((route, i) => {
              const active = i === state.index;
              const { title, drawerLabel, drawerIcon } = descriptors[
                route.key
              ].options;

              return (
                <Drawer.Item
                  key={route.key}
                  // @ts-ignore
                  label={
                    drawerLabel !== undefined
                      ? drawerLabel
                      : title !== undefined
                      ? title
                      : route.name
                  }
                  // @ts-ignore
                  icon={drawerIcon}
                  active={active}
                  onPress={() => {
                    console.log('vhgvjbhjbhjbk', route.name);
                    navigation.dispatch({
                      ...(active
                        ? DrawerActions.closeDrawer()
                        : CommonActions.navigate(route.name)),
                      target: state.key,
                    });
                  }}
                />
              );
            })} */}

          <Drawer.Item
            theme={{
              colors: { text: 'black' },
              fonts: { regular: { fontWeight: '400' } },
            }}
            label={i18n._(t`Profile`)}
            icon={() => (
              <View style={{ marginRight: -26 }}>
                <Icon source={require('@src/assets/images/profile.png')} />
              </View>
            )}
            active={false}
            onPress={() => {
              navigation.dispatch(DrawerActions.closeDrawer());
              navigation.navigate('Profile');
            }}
          />
          <Drawer.Item
            theme={{
              colors: { text: 'black' },
              fonts: { regular: { fontWeight: '400' } },
            }}
            label={i18n._(t`Wallet`)}
            icon={() => (
              <View style={{ marginRight: -26 }}>
                <Icon source={require('@src/assets/images/wallet.png')} />
              </View>
            )}
            active={false}
            onPress={() => {
              navigation.dispatch(DrawerActions.closeDrawer());
              navigation.navigate('Wallet');
            }}
          />
          {/* <Drawer.Item
            label={i18n._(t`Register new location`)}
            icon={() => (
              <Icon source={require('@src/assets/images/location-add.png')} />
            )}
            active={false}
            onPress={() => {}}
          />
          <Drawer.Item
            label={i18n._(t`Draft posts`)}
            icon={() => (
              <Icon
                source={require('@src/assets/images/directbox-receive.png')}
              />
            )}
            active={false}
            onPress={() => {}}
          />
          <Drawer.Item
            label={i18n._(t`Heros`)}
            icon={() => (
              <Icon source={require('@src/assets/images/medal-star.png')} />
            )}
            active={false}
            onPress={() => {}}
          />
          <Drawer.Item
            label={i18n._(t`Map`)}
            icon={() => <Icon source={require('@src/assets/images/map.png')} />}
            active={false}
            onPress={() => {}}
          />
          <Drawer.Item
            label={i18n._(t`Find people`)}
            icon={() => (
              <Icon source={require('@src/assets/images/user-search.png')} />
            )}
            active={false}
            onPress={() => {}}
          />
          <Drawer.Item
            label={i18n._(t`Terms and Conditions`)}
            icon={() => (
              <Icon source={require('@src/assets/images/task-square.png')} />
            )}
            active={false}
            onPress={() => {}}
          />
          <Drawer.Item
            label={i18n._(t`Block List`)}
            icon={() => (
              <Icon source={require('@src/assets/images/Block.png')} />
            )}
            active={false}
            onPress={() => {}}
          />
          <Drawer.Item
            label={i18n._(t`Support`)}
            icon={() => (
              <Icon source={require('@src/assets/images/Support.png')} />
            )}
            active={false}
            onPress={() => {}}
          />
          <Divider />
          <Drawer.Item
            label={i18n._(t`setting`)}
            icon={() => (
              <Icon source={require('@src/assets/images/setting.png')} />
            )}
            active={false}
            onPress={() => {}}
          /> */}
          <Drawer.Item
            theme={{
              colors: { text: 'black' },
              fonts: { regular: { fontWeight: '400' } },
            }}
            icon={() => (
              <View style={{ marginRight: -26 }}>
                <Icon source={require('@src/assets/images/logout.png')} />
              </View>
            )}
            label={i18n._(t`Logout`)}
            onPress={logout}
          />
        </Drawer.Section>
      </ScrollView>
    </Container>
  );
};

Component.displayName = 'DrawerContent';

export default React.memo(Component);
